// @flow

export const NAME_BUTTON_FOCUS_KEY = 'NAME_BUTTON_FOCUS_KEY'
export const ICON_BUTTON_FOCUS_KEY = 'ICON_BUTTON_FOCUS_KEY'
export const PARENTAL_RESTRICTIONS_BUTTON_FOCUS_KEY = 'PARENTAL_RESTRICTIONS_BUTTON_FOCUS_KEY'
export const DONE_BUTTON_FOCUS_KEY = 'DONE_BUTTON_FOCUS_KEY'
export const DELETE_PROFILE_BUTTON_FOCUS_KEY = 'DELETE_PROFILE_BUTTON_FOCUS_KEY'
